import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { BROKER_EXPERIENCE_V2 } from './flags';

/** Whether the broker experience is on: its routes, and the entry points that open it. */
export const useBrokerExperienceV2 = () => useFeatureIsOn(BROKER_EXPERIENCE_V2);
